import { memo, useMemo } from 'react';
import { Marker } from '@adamscybot/react-leaflet-component-marker';
import { MapPointIcon, TxCenterMapIcon } from '@icons';

import { TxCenterMarkerType } from '@lp/features/RoutePlanner/types';

export const TxCenterMarker = memo(({ location }: TxCenterMarkerType) => {
  const icon = useMemo(
    () => (
      <div className="relative flex flex-col justify-center items-center -translate-y-1/3">
        <div className="relative text-danger-10 mt-0.5 overflow-hidden">
          <MapPointIcon />
          <div className="absolute text-white top-1 left-[2px]">
            <TxCenterMapIcon width={19} height={19} />
          </div>
        </div>
        <div className="box-border w-3 h-3 rounded-full border-3 bg-white border-danger-10" />
      </div>
    ),
    [],
  );

  return (
    <Marker
      position={location}
      zIndexOffset={30}
      componentIconOpts={{
        disableClickPropagation: true,
      }}
      icon={icon}
    />
  );
});
